import actions from './actions'
import types from './constants'
import services from '../../services/diagnostic'
import get from 'lodash.get'
import set from 'lodash.set'

const fetchReport = (student) => async (dispatch, getState) => {

  const state = getState()
  const students = get(state, 'reports.roster.data.student')
  const classId = get(students.find(s=>s.id == student.value), 'classroom')
  const selectedLocale = get(state, 'reports.teacher.selectedLocale');

  dispatch(actions[types.DIAGNOSTIC_PENDING]())

  try{
    const [report, scores]= await services.fetchReport(student, selectedLocale, classId)

    // prep the data before dispatching to store into the state
    const [comprehension, wordRecognition] = get(scores, 'readingRopeReport.threads')
    const comprehensionDomain = get(comprehension, 'domains')
    const wordRecognitionDomain = get(wordRecognition, 'domains')
    // grab the scores from reading rope
    const vocabularyScore = get(comprehensionDomain.find( domain => domain.label === 'Vocabulary'), 'mastery.value')
    const phonologicalAwarenessScore = get(wordRecognitionDomain.find( domain => domain.label === 'Phonological Awareness'), 'mastery.value')
    const decodingScore = get(wordRecognitionDomain.find( domain => domain.label === 'Decoding'), 'mastery.value')
    const sightRecognitionScore = get(wordRecognitionDomain.find( domain => domain.label === 'Sight Recognition'), 'mastery.value')
    // replace scores in diagnostic report with reading rope scores
    set(report, 'vocab.score', vocabularyScore)
    set(report, 'phon.score', phonologicalAwarenessScore)
    set(report, 'decode.score', decodingScore)
    set(report, 'sight.score', sightRecognitionScore)
    // send it to state
    dispatch(actions[types.DIAGNOSTIC_COMPLETE](report))
  }catch(error){
    console.log(error)
    dispatch(actions[types.DIAGNOSTIC_ERROR](error))
  }

}

export default {
  fetchReport,
}
